export default __webpack_public_path__ + "static/media/KZ.T.04.0758 black.0edf9d28.svg";